module.exports = __webpack_public_path__ + "img/afiliados-imagen.8ab1c855.png";